import { handleOrganisationRoutes } from '@/helpers/router';
import { permissionActionName, permissionSubjectName, PermissionSuffix } from '@/service/api/core/enums/permission';
import { PermissionEnum } from '@vini-wine/core-enums';
export default [
    {
        path: '/organisation/:orgUuid/bank-entries',
        name: 'organisation-bank-entries',
        component: () => import('@/views/organisation/bank-entries/Index.vue'),
        meta: {
            resource: permissionSubjectName(PermissionEnum.BANK_ENTRY_LINE__VIEW, PermissionSuffix.USER_ORGANISATION),
            action: permissionActionName(PermissionEnum.BANK_ENTRY_LINE__VIEW),
            pageTitle: 'pageTitles.bankEntries.bankEntries',
            breadcrumb: [
                {
                    text: 'breadcrumbs.bankEntries.bankEntries.more',
                },
                {
                    text: 'breadcrumbs.bankEntries.bankEntries.bankEntries',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            handleOrganisationRoutes(to);
            next();
        },
    },
];
